import { useEffect, useState } from 'react';
import {
  initTelegram,
  getTelegramUser,
  isRunningInTelegram,
  hapticImpact,
  hapticNotification,
  hapticSelect,
} from '@/services/telegram';
import type { TelegramUser } from '@/types/user';

export interface UseTelegramResult {
  user: TelegramUser | null;
  isTelegram: boolean;
  hapticImpact: typeof hapticImpact;
  hapticNotification: typeof hapticNotification;
  hapticSelect: typeof hapticSelect;
}

export function useTelegram(): UseTelegramResult {
  const [user, setUser] = useState<TelegramUser | null>(null);
  const [isTelegram, setIsTelegram] = useState(false);

  useEffect(() => {
    initTelegram();
    setUser(getTelegramUser());
    setIsTelegram(isRunningInTelegram());
  }, []);

  return { user, isTelegram, hapticImpact, hapticNotification, hapticSelect };
}
